<template>
  <proa-modal
    :modal="modal"
    :title="$t('common.modals.uploadProjectAttachmentModal.title')"
    @close="$emit('close')"
  >
    <div class="uploaded-field">
      <div v-if="newProjectAttachment.attachmentFileName" class="attachment">
        <span class="attachment-icon">
          <img :src="require('@/assets/images/icons/file.png')"/>
        </span>
        <span class="attachment-file-name">
          {{ newProjectAttachment.attachmentFileName }}
        </span>
      </div>
      <span v-else>
        {{ $t('common.modals.uploadProjectAttachmentModal.unselectedMessage') }}
      </span>
    </div>
    <proa-button
      @click.native="onClickSelectFile"
      :disabled="requesting"
    >
      {{ $t('common.modals.uploadProjectAttachmentModal.selectFile') }}
    </proa-button>
    <template v-slot:footer>
      <proa-button
        @click.native="$emit('close')"
        :disabled="requesting"
        class="mr-2"
      >
        {{ $t('common.cancel') }}
      </proa-button>
      <proa-button
        @click.native="$emit('onClickUploadProjectAttachment', newProjectAttachment)"
        :loading="requesting"
        :disabled="!newProjectAttachment.attachmentFileName"
        variant="primary"
      >
        {{ $t('common.upload') }}
      </proa-button>
    </template>
    <attachment-file-size-limit-error-modal
      :fileNames="attachmentFileSizeLimitErrorFileNames"
      @close="attachmentFileSizeLimitErrorFileNames = []"
    />
  </proa-modal>
</template>

<script>
import VirtualInputFile from '@/lib/VirtualInputFile'
import AttachmentFileSizeLimitErrorModal from '@/components/organisms/AttachmentFileSizeLimitErrorModal'

export default {
  name: 'UploadProjectAttachmentModal',
  components: {
    AttachmentFileSizeLimitErrorModal
  },
  props: {
    modal: Boolean,
    requesting: Boolean
  },
  data() {
    return {
      newProjectAttachment: {
        attachmentFileName: null,
        attachmentFile: null
      },
      attachmentFileSizeLimitErrorFileNames: []
    }
  },
  methods: {
    initNewProjectAttachment: function() {
      this.newProjectAttachment = {
        attachmentFileName: null,
        attachmentFile: null
      }
    },
    onClickSelectFile: function() {
      const virtualInputFile = new VirtualInputFile()

      virtualInputFile.on('fileSizeLimitError', (fileName) => {
        this.attachmentFileSizeLimitErrorFileNames.push(fileName)
      })

      virtualInputFile.on('fileRead', (file) => {
        this.newProjectAttachment = {
          attachmentFileName: file.name,
          attachmentFile: file.base64Data
        }
      })
    }
  },
  watch: {
    modal: function(value) {
      if (!value) return
      this.initNewProjectAttachment()
    }
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";

.uploaded-field {
  margin-bottom: 10px;
}

.attachment {
  position: relative;
  width: 200px;
  height: 40px;
  display: flex;
  align-items: center;
  font-size: 12px;
  border: 1px solid $online-blue-color;
  color: $online-blue-color;
  border-radius: 4px;
}

.attachment-file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.attachment-icon {
  padding: 5px;
  img {
    width: 30px;
    height: 30px;
  }
}
</style>
